import PropTypes from 'prop-types';

// material-ui
import { Typography, Tooltip, Box } from '@mui/material';

// third-party
import { format } from 'date-fns';
import { useIntl } from 'react-intl';

// ==============================|| RENDER EXECUTION SETTINGS ||============================== //

const RenderExecSettingsGridCell = ({ value }) => {
    const intl = useIntl();

    if (!value) return <Box />;

    const { estimatedStartDate, estimatedEndDate, estimatedDurationTime, actualStartDate, actualEndDate, actualDurationTime } = value;

    return (
        <Tooltip
            title={
                <Typography variant="inherit" color="inherit">
                    <>
                        {estimatedStartDate &&
                            `${intl.formatMessage({ id: 'entity-workmgmt-execsettings-estimatedstartdate' })}: 
                            ${format(new Date(estimatedStartDate), 'd/MM/yyyy HH:mm')}
                        `}
                        {estimatedEndDate &&
                            `, ${intl.formatMessage({ id: 'entity-workmgmt-execsettings-estimatedenddate' })}: 
                            ${format(new Date(estimatedEndDate), 'd/MM/yyyy HH:mm')}
                        `}
                        {estimatedDurationTime &&
                            `, ${intl.formatMessage({ id: 'entity-workmgmt-execsettings-estimateddurationtime' })}: 
                            ${estimatedDurationTime} ${intl.formatMessage({ id: 'ui-comp-form-quantity-hours' })}
                        `}
                        <br />
                        {actualStartDate &&
                            `${intl.formatMessage({ id: 'entity-workmgmt-execsettings-actualstartdate' })}: 
                            ${format(new Date(actualStartDate), 'd/MM/yyyy HH:mm')}
                        `}
                        {actualEndDate &&
                            `, ${intl.formatMessage({ id: 'entity-workmgmt-execsettings-actualenddate' })}: 
                            ${format(new Date(actualEndDate), 'd/MM/yyyy HH:mm')}
                        `}
                        {actualDurationTime &&
                            `, ${intl.formatMessage({ id: 'entity-workmgmt-execsettings-actualdurationtime' })}: 
                            ${actualDurationTime} ${intl.formatMessage({ id: 'ui-comp-form-quantity-hours' })}
                        `}
                    </>
                </Typography>
            }
        >
            <Typography color="inherit" variant="inherit">
                {estimatedStartDate && `${format(new Date(estimatedStartDate), 'd/MM/yyyy HH:mm')}`}
                {estimatedEndDate && `- ${format(new Date(estimatedEndDate), 'd/MM/yyyy HH:mm')}`}
            </Typography>
        </Tooltip>
    );
};

RenderExecSettingsGridCell.propTypes = {
    value: PropTypes.object
};

export default RenderExecSettingsGridCell;
